import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<header><div class=\"gd-purple shadow-purple py-10\"><div class=\"container text-center\"><div><h1 class=\"text-4xl sm:text-8xl text-white font-medium mr-10\">Meraj</h1><h1 class=\"text-3xl sm:text-6xl text-gray-100 ml-10 mt-5\">Sheikhha</h1><div class=\"flex justify-center\"><p class=\"bg-indigo-200 px-3 py-1 text-sm text-gray-700 rounded mt-8\">Full stack developer</p></div></div></div></div></header>", 1)
const _hoisted_2 = { class: "mb-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-4xl font-medium mt-10 border-b-4 rounded pb-2 border-indigo-200" }, "Portfolio")
], -1)
const _hoisted_4 = { class: "container gap-8 grid pr-cards mt-5" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"px-3 pb-3\"><h3 class=\"font-bold mt-3\">Vo CRM</h3><p class=\"text-gray-500 text-sm\"> a full CRM which can feed your company needs and analyze your customers, products and..</p><p class=\"font-medium text-sm text-gray-500\">note: still in progress</p><ul class=\"text-gray-500 text-sm list-disc pl-4 mt-3\"><li class=\"text-blue-500\">Golang</li><li class=\"text-pink-500\">Mongodb, Postgres</li><li class=\"text-green-500\">Vue</li></ul></div>", 1)
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"px-3 pb-3\"><h3 class=\"font-bold mt-3\">Vision - Content Service</h3><p class=\"text-gray-500 text-sm\"> a service to set your data schema and add content for it, with a full filemanager with Resumable upload function.</p><ul class=\"text-gray-500 text-sm list-disc pl-4 mt-3\"><li class=\"text-blue-500\">Golang</li><li class=\"text-pink-500\">Mongodb, Postgres</li><li class=\"text-green-500\">Vue</li></ul></div>", 1)
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"px-3 pb-3\"><h3 class=\"font-bold mt-3\">Erocket</h3><p class=\"text-gray-500 text-sm\">wordpress theme for my personal blog, i used to publish programming tutorials on it.</p><ul class=\"text-gray-500 text-sm list-disc pl-4 mt-3\"><li class=\"text-indigo-500\">Wordpress PHP</li><li class=\"text-blue-500\">HTML, css</li><li class=\"text-yellow-500\"> javascript </li></ul></div>", 1)
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"px-3 pb-3\"><h3 class=\"font-bold mt-3\">Looketo</h3><p class=\"text-gray-500 text-sm\">HTML theme</p><ul class=\"text-gray-500 text-sm list-disc pl-4 mt-3\"><li class=\"text-blue-500\">HTML, css</li><li class=\"text-yellow-500\"> javascript </li></ul></div>", 1)
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"px-3 pb-3\"><h3 class=\"font-bold mt-3\">IranArma</h3><p class=\"text-gray-500 text-sm\">Android app, php api, telegram bot</p><ul class=\"text-gray-500 text-sm list-disc pl-4 mt-3\"><li class=\"text-indigo-500\">Wordpress PHP</li><li class=\"text-blue-500\">HTML, css</li><li class=\"text-yellow-500\"> javascript </li></ul></div>", 1)
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"px-3 pb-3\"><h3 class=\"font-bold mt-3\">WebpConverter</h3><p class=\"text-gray-500 text-sm\">a website to convert images to webp format</p><ul class=\"text-gray-500 text-sm list-disc pl-4 mt-3\"><li class=\"text-indigo-500\">PHP</li><li class=\"text-pink-500\">Mysql</li><li class=\"text-blue-500\">HTML, css</li><li class=\"text-yellow-500\"> javascript </li></ul></div>", 1)
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"px-3 pb-3\"><h3 class=\"font-bold mt-3\">beasy blog</h3><p class=\"text-gray-500 text-sm\">a blog using nuxtjs and backed by my Content Service api</p><ul class=\"text-gray-500 text-sm list-disc pl-4 mt-3\"><li class=\"text-indigo-500\">Nuxtjs</li><li class=\"text-blue-500\">HTML, css</li><li class=\"text-yellow-500\"> javascript </li><li class=\"text-green-500\"> Vision - my content service </li></ul></div>", 1)
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"px-3 pb-3\"><h3 class=\"font-bold mt-3\">Twitter farsi trends</h3><p class=\"text-gray-500 text-sm\">Android app</p><ul class=\"text-gray-500 text-sm list-disc pl-4 mt-3\"><li class=\"text-indigo-700\">PHP Laravel, E2E encryption data between client and server (RSA, AES), and also store client google adID to send push notification using firebase api</li><li class=\"text-pink-500\">Mysql</li><li class=\"text-indigo-500\">Kotlin</li></ul></div>", 1)
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<div class=\"px-3 pb-3\"><h3 class=\"font-bold mt-3\">I need proxy</h3><p class=\"text-gray-500 text-sm\">Android app, php api, telegram bot</p><ul class=\"text-gray-500 text-sm list-disc pl-4 mt-3\"><li class=\"text-indigo-700\">PHP</li><li class=\"text-pink-500\">Mysql</li><li class=\"text-indigo-500\">Kotlin</li></ul></div>", 1)
const _hoisted_23 = ["src"]
const _hoisted_24 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("main", null, [
      _createElementVNode("section", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("article", {
            class: "bg-white rounded cursor-pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal([require('@/assets/portfolio/voCRM.png')],'do you want a service to manage your customers, employees, products, orders and analyze them? the Vo CRM could help you, my goal is build a dashboard for businesses to manage the works going on in their company, with a all in one service on the clouds, you could analyze your customers based on their shopping activity and also track orders which are in progress and...')))
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("img", {
                src: require('@/assets/portfolio/voCRM.png'),
                class: "h-44 object-cover w-full rounded-t"
              }, null, 8, _hoisted_5)
            ]),
            _hoisted_6
          ]),
          _createElementVNode("article", {
            class: "bg-white rounded cursor-pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal([require('@/assets/portfolio/content.png'),require('@/assets/portfolio/content-2.png'),require('@/assets/portfolio/content-filemanager.png')],'a service to set your data schema and add content for it, with a full filemanager with Resumable upload function, and also content analyzer, you could make anything you want with this service, like a CRM, orders management, employees management, ecommerce back-end and...')))
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("img", {
                src: require('@/assets/portfolio/content.png'),
                class: "h-44 object-cover w-full rounded-t"
              }, null, 8, _hoisted_7)
            ]),
            _hoisted_8
          ]),
          _createElementVNode("article", {
            class: "bg-white rounded cursor-pointer",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openModal(require('@/assets/portfolio/erocket.ir.png'))))
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("img", {
                src: require('@/assets/portfolio/erocket.ir.png'),
                class: "h-44 object-cover w-full rounded-t"
              }, null, 8, _hoisted_9)
            ]),
            _hoisted_10
          ]),
          _createElementVNode("article", {
            class: "bg-white rounded cursor-pointer",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openModal(require('@/assets/portfolio/looketo.png'))))
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("img", {
                src: require('@/assets/portfolio/looketo.png'),
                class: "h-44 object-cover w-full rounded-t"
              }, null, 8, _hoisted_11)
            ]),
            _hoisted_12
          ]),
          _createElementVNode("article", {
            class: "bg-white rounded cursor-pointer",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openModal(require('@/assets/portfolio/iranarma.png'))))
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("img", {
                src: require('@/assets/portfolio/iranarma.png'),
                class: "h-44 object-cover w-full rounded-t"
              }, null, 8, _hoisted_13)
            ]),
            _hoisted_14
          ]),
          _createElementVNode("article", {
            class: "bg-white rounded cursor-pointer",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openModal(require('@/assets/portfolio/webp-converter.png'))))
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("img", {
                src: require('@/assets/portfolio/webp-converter.png'),
                class: "h-44 object-cover w-full rounded-t"
              }, null, 8, _hoisted_15)
            ]),
            _hoisted_16
          ]),
          _createElementVNode("article", {
            class: "bg-white rounded cursor-pointer",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openModal(require('@/assets/portfolio/beasy.png'))))
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("img", {
                src: require('@/assets/portfolio/beasy.png'),
                class: "h-44 object-cover w-full rounded-t"
              }, null, 8, _hoisted_17)
            ]),
            _hoisted_18
          ]),
          _createElementVNode("article", {
            class: "bg-white rounded cursor-pointer",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openModal(require('@/assets/portfolio/TwitterFarsiTrends.jpg'))))
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("img", {
                src: require('@/assets/portfolio/TwitterFarsiTrends.jpg'),
                class: "h-44 object-cover w-full rounded-t"
              }, null, 8, _hoisted_19)
            ]),
            _hoisted_20
          ]),
          _createElementVNode("article", {
            class: "bg-white rounded cursor-pointer",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openModal(require('@/assets/portfolio/ineedproxy.jpg'),' this app use leaked unofficial telegram apis and get their mtproto proxies and check if they are up and then store them on server')))
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("img", {
                src: require('@/assets/portfolio/ineedproxy.jpg'),
                class: "h-44 object-cover w-full rounded-t"
              }, null, 8, _hoisted_21)
            ]),
            _hoisted_22
          ])
        ])
      ])
    ]),
    _createVNode(_component_modal, {
      ref: "showImageModal",
      rounded: "rounded"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.img, (i) => {
          return (_openBlock(), _createElementBlock("img", {
            key: i,
            src: i
          }, null, 8, _hoisted_23))
        }), 128)),
        (_ctx.tip)
          ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_ctx.tip), 1))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$refs.showImageModal.closeModal())),
          type: "button",
          class: "py-2 px-4 rounded bg-indigo-100 transition hover:shadow-inner hover:bg-indigo-200 outline-none"
        }, "Close")
      ]),
      _: 1
    }, 512)
  ], 64))
}